import PropTypes from 'prop-types';

import { EnhancedReturnDetailsGridLayout } from '../enhanced-return-details-grid-layout';
import './container-query-layout.css';

export const LayoutContainer = ({ addressColumnContent, costSummaryColumnContent, rmaColumnContent }) => {
  return (
    <div className='enhanced-return-details-grid-container' data-type='container-query'>
      <EnhancedReturnDetailsGridLayout
        addressColumnContent={addressColumnContent}
        className='enhanced-return-details-grid'
        costSummaryColumnContent={costSummaryColumnContent}
        rmaColumnContent={rmaColumnContent}
      />
    </div>
  );
};

LayoutContainer.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
  costSummaryColumnContent: PropTypes.node.isRequired,
};
